import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import INSIGHTS from '../data/insights';

export default function Insights() {
  return (
    <>
      <PageHero
        modifier="insights"
        kicker="Thought Leadership"
        title="Insights"
        desc="Architecture guidance, best practices and expert perspectives on SAP integration, analytics and ERP modernization."
      />
      <section className="section section-soft">
        <div className="container grid grid-3 animate-cards">
          {INSIGHTS.map((ins, i) => (
            <div className="card card--insight" key={i}>
              <span className="insight-tag">{ins.tag}</span>
              <h3>{ins.title}</h3>
              <p>{ins.desc}</p>
              <div className="insight-footer">
                <span className="read-badge">&#x23F1; {ins.readTime}</span>
                <Link className="link" to={`/insights/${i}`} style={{ fontSize: 13 }}>Read article &#8594;</Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
